import { dew as _validCallableDew } from "./valid-callable";
import { dew as _forEachDew } from "./for-each";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var callable = _validCallableDew(),
      forEach = _forEachDew(),
      call = Function.prototype.call;

  exports = function (obj, cb
  /*, thisArg*/
  ) {
    var result = {},
        thisArg = arguments[2];
    callable(cb);
    forEach(obj, function (value, key, targetObj, index) {
      result[key] = call.call(cb, thisArg, value, key, targetObj, index);
    });
    return result;
  };

  return exports;
}